/**
 * 获取压缩后图片Url
 * @param {string} url
 * @param {number} width
 * @param {number} quality
 */
export const getImageUrl = (_url, width, quality) => {
    return getImageConfigUrl(_url, {
        w: width,
        q: quality
    });
};
/**
* 获取压缩后图片Url
* @param {string} url
* @param {object} config {w: 宽度, h: 高度一般无需指定, q: 质量}
*/
export const getImageConfigUrl = (_url, config) => {
    let url = _url;
    try {
        url = url.replace('http://', 'https://');
        let hasParams = false;
        if (url.indexOf('.png@') >= 0 || url.indexOf('.jpg@') >= 0) {
            return url;
        }
        if (url.indexOf('.png') >= 0 || url.indexOf('.jpg') >= 0) {
            if (config && config.w && typeof config.w === 'number' && !isNaN(config.w)) {
                url = url + '@' + config.w + 'w';
                hasParams = true;
            }
            if (config && config.h && typeof config.h === 'number' && !isNaN(config.h)) {
                url = hasParams ? url + '_' + config.h + 'h' : url + '@' + config.h + 'h';
                hasParams = true;
            }
            if (config && config.q && typeof config.q === 'number' && !isNaN(config.q)) {
                url = hasParams ? url + '_' + config.q + 'q' : url + '@' + config.q + 'q';
            }
        }
    }
    catch (error) {
        console.warn(error);
    }
    return url;
};
export const FLIGHT_ARROW_ONEWAY_IMAGE_URL = 'https://img.meituan.net/htusergrowth/5ad1502d086a6db8c8aa7b94a5a9e1e61053.png';
export const FLIGHT_ARROW_ONEWAY_IMAGE_URL_SCROLL = 'https://p0.meituan.net/ingee/55450093509cf81fc0cf448cf88f3bb3370.png';
